import { Tooltip } from "./Tooltip";

export const RestrictedAccessTooltipContent = "Contact an organisation manager to update your access for this feature";

export const RestrictedAccessTooltip: React.FunctionComponent = () => {
	return (
		<Tooltip
			id="unavailable-feature-tooltip"
			content={RestrictedAccessTooltipContent}
		/>
	);
}

export const AlreadyLinkedCustomerTooltipContent = "This entity is already monitored.";
export const AlreadyLinkedCustomerTooltip: React.FunctionComponent = () => {
	return (
		<Tooltip
			id="already-linked-customer-tooltip"
			content={AlreadyLinkedCustomerTooltipContent}
		/>
	);
}